export default __webpack_public_path__ + "img/aguila-original.png?1572";